import styled from 'styled-components';

export const Container = styled.div`
  background: var(--color-dark-50);
`;
